// src/api.js
//
// Enquiry submission.
//
// The API commits the row before it attempts the notification email, so a 201
// means the enquiry is stored even if the email later fails.

const BASE = process.env.REACT_APP_API_URL;

export async function submitEnquiry(payload) {
  const res = await fetch(`${BASE}/v1/enquiries`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (res.ok) return res.json();

  // The API returns a small set of known error codes; anything else is
  // reported generically rather than leaking a stack trace to the visitor.
  let code = "unknown";
  try {
    const body = await res.json();
    code = body.error || code;
  } catch {
    // non-JSON response, keep the default
  }

  const messages = {
    verification_failed: "The security check did not pass. Please try again.",
    email_or_phone_required: "Please give either an email address or a phone number.",
  };

  const err = new Error(
    messages[code] ||
      (res.status === 429
        ? "Too many enquiries from this connection. Please wait a minute and try again."
        : "Something went wrong sending your enquiry. Please call us instead.")
  );
  err.code = code;
  throw err;
}